import { render } from "./DrugEdit.vue?vue&type=template&id=321b0f20&scoped=true"
import script from "./DrugEdit.vue?vue&type=script&lang=js"
export * from "./DrugEdit.vue?vue&type=script&lang=js"

import "./DrugEdit.vue?vue&type=style&index=0&id=321b0f20&scoped=true&lang=scss"

import exportComponent from "H:\\ideaProject\\vue\\fiveG-project\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-321b0f20"]])

export default __exports__